import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'
import { push } from 'react-router-redux'

import { updateCalendar } from '../actions/calendars'

import { renderInputField, renderSelectField } from '../utils/forms'

class CalendarPricesAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      deleting: false,
    }

    this.submit = this.submit.bind(this);
    this.deletePrices = this.deletePrices.bind(this);
  }

  submit(props) {
    const { calendar } = this.props
    this.setState({ loading: true }); // Start loading

    return this.props.updateCalendar(calendar._id, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        this.setState({ loading: false }); // Stop loading
        return response
      })
      .catch(error => {
        this.setState({ loading: false }); // Stop loading on error as well
        throw error;
      });
  }

  deletePrices(values) {
    const { calendar } = this.props;

    this.setState({ deleting: true, loading: true });

    const props = {
      ...values,
      price: 0,
      delete: true
    };

    return this.props.updateCalendar(calendar._id, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          });
        }
        this.setState({ loading: false, deleting: false });
        return response;
      })
      .catch(error => {
        this.setState({ loading: false, deleting: false });
        throw error;
      });
  }


  render() {
    const { error, submitting, handleSubmit, category, customer, role, calendar, contracts } = this.props

    if (!customer) {
      return (
        <LoadingProgress />
      )
    }

    // Build allowed locker type codes for this customer
    // ADMIN sees all types; others see only types present in their contracts
    const isAdmin = role === 'ADMIN';
    let allowedTypes = null; // null = show all
    if (!isAdmin && contracts && contracts.length > 0 && calendar) {
      const calCustomerId = calendar.Customer
        ? (typeof calendar.Customer === 'object' ? String(calendar.Customer._id) : String(calendar.Customer))
        : null;
      // Collect all contracts belonging to this calendar's customer
      const customerContracts = calCustomerId
        ? contracts.filter(c => {
            const cid = c.Customer
              ? (typeof c.Customer === 'object' ? String(c.Customer._id) : String(c.Customer))
              : null;
            return cid === calCustomerId;
          })
        : contracts;
      // Union of LOCKER* item types across all matching contracts
      const typeSet = new Set();
      customerContracts.forEach(contract => {
        (contract.Items || []).forEach(item => {
          if (item.item && item.item.startsWith('LOCKER')) {
            typeSet.add(item.item.replace('LOCKER', ''));
          }
        });
      });
      if (typeSet.size > 0) allowedTypes = typeSet;
    }

    const todayStr = new Date().toISOString().split('T')[0];

    return (
      <form onSubmit={handleSubmit(this.submit)} className="mb-3">
        {submitting ? (<div className="row"></div>) : (
          <div className="row">
            <div className="col">
              <Field name="startDate"
                component={renderInputField}
                type="date"
                min={todayStr}
                label="Fecha inicio" />
            </div>
            <div className="col">
              <Field name="endDate"
                component={renderInputField}
                type="date"
                min={todayStr}
                label="Fecha fin" />
            </div>
            <div className="col">
              <Field name="zone"
                component={renderSelectField}
                label="Zona">
                <option value="">Selecciona una zona...</option>
                {customer.Zones.map(zone => {
                  return (
                    <option value={zone.Zone} key={zone.Zone}>
                      {zone.Zone} / {zone.Description}
                    </option>
                  )
                })}
              </Field>
            </div>
            <div className="col">
              {category === 'BAQUEIRA' ? (
                <Field
                  name="type"
                  component={renderSelectField}
                  label="Tipo de Taquilla"
                >
                  <option value="BN3XL">2 PAX</option>
                  <option value="CN3XL">3 PAX</option>
                  <option value="BW3XL">4 PAX</option>
                  <option value="CW3XL">3 PAX SS</option>
                  <option value="BNS">Standard</option>
                  <option value="BNM">Medium</option>
                </Field>
              ) : (() => {
                // Full catalogue: [code, label]
                const allTypes = [
                  ['BNS', 'Standard'],          ['CNS', 'Standard Carga'],
                  ['BWS', 'Standard XL'],        ['CWS', 'Standard Carga XL'],
                  ['BNM', 'Medium'],             ['CNM', 'Medium Carga'],
                  ['BWM', 'Medium XL'],          ['CWM', 'Medium Carga XL'],
                  ['BNL', 'Large'],              ['CNL', 'Large Carga'],
                  ['BWL', 'Large XL'],           ['CWL', 'Large Carga XL'],
                  ['BNXL', 'Large 4'],           ['CNXL', 'Large 4 Carga'],
                  ['BWXL', 'Large 4 XL'],        ['CWXL', 'Large 4 Carga XL'],
                  ['BN2XL', 'Large 5'],          ['CN2XL', 'Large 5 Carga'],
                  ['BW2XL', 'Large 5 XL'],       ['CW2XL', 'Large 5 Carga XL'],
                  ['BN3XL', 'Ski'],              ['CN3XL', 'Ski Carga'],
                  ['BW3XL', 'Ski XL'],           ['CW3XL', 'Ski Carga XL'],
                  ['XNS', 'Standard Cupón'],     ['XWS', 'Standard XL Cupón'],
                  ['XNM', 'Medium Cupón'],       ['XWM', 'Medium XL Cupón'],
                  ['XNL', 'Large Cupón'],        ['XWL', 'Large XL Cupón'],
                  ['XNXL', 'Large 4 Cupón'],     ['XWXL', 'Large 4 XL Cupón'],
                  ['XN2XL', 'Large 5 Cupón'],    ['XW2XL', 'Large 5 XL Cupón'],
                  ['XN3XL', 'Ski Cupón'],        ['XW3XL', 'Ski XL Cupón'],
                ];
                const visible = allowedTypes
                  ? allTypes.filter(([code]) => allowedTypes.has(code))
                  : allTypes;
                return (
                  <Field
                    name="type"
                    component={renderSelectField}
                    label="Tipo de Taquilla"
                  >
                    <option value="">Selecciona un tipo...</option>
                    {visible.map(([code, label]) => (
                      <option value={code} key={code}>{label}</option>
                    ))}
                  </Field>
                );
              })()}
            </div>
            <div className="col">
              <Field
                name="price"
                component={renderInputField}
                type="number"
                label="Precio"
              />
            </div>
          </div>
        )}
        <div className="form-row">
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
        <div className="form-row justify-content-center mt-3">
          {submitting ? (<div className="loading-wheel"></div>) : (
            <>
              <button className="btn bg-vw-dark text-white mr-1"
                type="submit"
                disabled={submitting}>
                <i className="fas fa-edit mr-1"></i>
                Añadir precios
              </button>
              <button className="btn btn-danger ml-2"
                type="button"
                onClick={() => handleSubmit(this.deletePrices)()}
                disabled={submitting}>
                <i className="fas fa-trash mr-1"></i>
                Eliminar precios
              </button>
            </>
          )}
        </div>
      </form>
    )
  }
}

// Validation function to check if the price is 0
const validate = values => {
  const errors = {}

  // if (values.price === 0 && !this.state.deleting) {
  //   errors.price = 'El precio no puede ser 0'
  // }

  // You can add other validation rules here

  return errors
}

CalendarPricesAddForm = reduxForm({
  form: 'CalendarPricesAddForm',
  validate,  // Add the validate function here
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/calendars/${result.response._id}`)
  },
  enableReinitialize: true
})(CalendarPricesAddForm)

const selector = formValueSelector('CalendarPricesAddForm');

const mapStateToProps = state => {
  const currentYear = new Date().getFullYear();

  const formatDateLocal = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const today = formatDateLocal(new Date());
  const lastDayOfYear = formatDateLocal(new Date(currentYear, 11, 31));

  return {
    calendar: state.calendars.calendar,
    role: state.auth.role,
    category: state.auth.category,
    id: state.auth.id,
    contracts: state.contracts ? state.contracts.contracts : [],
    values: selector(state, 'startDate', 'endDate', 'zone', 'type', 'price'),
    initialValues: {
      startDate: today,
      endDate: lastDayOfYear,
      zone: '1',
      type: 'BN3XL',
      price: 0
    }
  };
};

const mapDispatchToProps = dispatch => ({
  updateCalendar: bindActionCreators(updateCalendar, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CalendarPricesAddForm)
